import { border, mutedSurface, focus } from "../UI/tokens";
import { Button, CloseButton, Modal } from "react-bootstrap";
import styled from "styled-components";

export const DivFiles = styled.div`
border: 1px dashed ${border}; border-radius: 12px; padding: 28px 20px;
 background: ${mutedSurface}; text-align: center; cursor: pointer;
 &:hover { border-color: currentColor; } ${focus}
`

export const DeleteButton = styled(CloseButton)`
    font-size: 1.5vh;
    margin-left: 1vw;    
`

export const ModalPreview = styled(Modal)`
    .custom-modal {
        max-width: 80%;
        width: 80%;
        height: 100%;
        margin: auto; /* Adiciona margem automática para centralizar horizontalmente */
        transform: translate(-50%, -50%); /* Centraliza vertical e horizontalmente */
    }

    .modal-content {
        height: 100vh;
        overflow: auto; /* Adiciona uma barra de rolagem caso o conteúdo ultrapasse a altura da tela */
    }
    
    @media (max-width: 767px) {
        .custom-modal {
            width: 100%;
            height: 100%;
        }
    }
`